const LinkOut = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
    <g clipPath="url(#a)">
      <path
        stroke="#79553A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M10.5 0H14v3.5M13.25.75 9.5 4.5M8 1H3.5A1.5 1.5 0 0 0 2 2.5v8A1.5 1.5 0 0 0 3.5 12h8a1.5 1.5 0 0 0 1.5-1.5V6"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default LinkOut;
